module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/sp-cover-2-6f3098f7817bac4a7071eefd6b7b5dcc.webp";